import React from "react";

import classnames from "classnames";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import { StandaloneTrigger } from "Cobalt/Modal";

import FilterModal from "./mobileFilterButton/MobileFilterModal";

import makeBem from "Utils/makeBem";

export const bem = makeBem("ModalFilterButton");

// Presentational Component for the button that triggers the modal filter
const ModalFilterButtonDumb = ({ children, ...rest }) => (
  <div className={classnames(bem())} {...rest}>
    {children}
  </div>
);

// Track clicks on the HOC that wraps the modal with the button
const trackFilterClick = (props, trackingKey, e) => {
  AnalyticsTracking.trackEvent("filter_clicked", {
    location: "horizontal-scrolling-bar",
    filter: trackingKey,
  });

  props.onClick(e);
};

type Props = {
  trackingKey: string;
  children: React.ReactNode;
  renderFilter: (arg0: any) => React.ReactNode;
  title: string;
};

// Wrap Presentational Component with trigger for Modal and tracking
class ModalFilterButton extends React.Component<Props> {
  render() {
    return (
      <StandaloneTrigger
        trigger={(props) => (
          <ModalFilterButtonDumb
            onClick={(e) => {
              trackFilterClick(props, this.props.trackingKey, e);
            }}
          >
            {this.props.children}
          </ModalFilterButtonDumb>
        )}
        modal={(props) => {
          const newProps = { ...props, ...this.props };
          return <FilterModal {...newProps} />;
        }}
      />
    );
  }
}

export default ModalFilterButton;
